export default {
  path: '/2019VoteForShangYouHao',
  name: '2019VoteForShangYouHao',
  component: () => import('./Home.vue'),
  redirect: '/2019VoteForShangYouHao/ListPage',
  meta: {
    title: '2019用户最喜爱上游号评选',
  },
  children: [
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: '2019VoteForShangYouHao/ListPage',
      meta: {
        title: '2019用户最喜爱上游号评选',
      },
    },
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019VoteForShangYouHao/SelectRules',
      meta: {
        title: '2019用户最喜爱上游号评选',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019VoteForShangYouHao/DetailPage',
      meta: {
        title: '2019用户最喜爱上游号评选',
      },
    },
  ],
};
